import { render, staticRenderFns } from "./SettlementModal.vue?vue&type=template&id=5a83b718&scoped=true"
import script from "./SettlementModal.vue?vue&type=script&lang=js"
export * from "./SettlementModal.vue?vue&type=script&lang=js"
import style0 from "./SettlementModal.vue?vue&type=style&index=0&id=5a83b718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a83b718",
  null
  
)

export default component.exports